const u = up.util;
up.RenderResult = class RenderResult {
    constructor({ layer, target, renderOptions = {}, partialResults = [] } = {}) {
        this.layer = layer;
        this.target = target;
        this.renderOptions = renderOptions;
        this.fragments = this._partialPhase(partialResults, 'fragments').flat();
        this.finished = this._finish(partialResults);
    }
    _partialPhase(partialResults, phase, extraValue) {
        return u.compact([...u.map(partialResults, phase), extraValue]);
    }
    async _finish(partialResults) {
        let finishedPromises = this._partialPhase(partialResults, 'finished');
        let verifyFns = this._partialPhase(partialResults, 'verifyFinished', this.renderOptions.verifyFinished);
        await Promise.all(finishedPromises);
        let finishedResult = this;
        for (let verifyFn of verifyFns) {
            let verifyerResult = await verifyFn(finishedResult);
            finishedResult = verifyerResult || finishedResult;
        }
        return finishedResult;
    }
    get none() {
        return !this.fragments.length;
    }
    get fragment() {
        return this.fragments[0];
    }
    get ok() {
        return !this.renderOptions.didFail;
    }
};
